<template>
	<v-dialog
			v-model="showDialog_"
			persistent
			width="1050px">
		<template v-slot:activator="{ on }">
			<v-btn	class="customVBtn"
					v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>design_services</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">SERVICE</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<!-- tab -->
			<v-row class="px-2" align="center">
				<v-col>
					<v-tabs	v-model="selectedTab_"
							color="success">
						<template v-for="key in tabs_">
							<v-tab :key="key" v-text="key" />
						</template>
					</v-tabs>
				</v-col>
				<!-- debugger -->
				<template v-if="debugMode">
					<v-col cols="auto">
						<v-dialog width="750px">
							<template v-slot:activator="{ on }">
								<v-btn	class="customVBtn"
										color="error"
										icon
										v-on="on">
									<v-icon>error</v-icon>
								</v-btn>
							</template>
							<v-card class="customVCard">
								<!-- tabs -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">tabs_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="tabs_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- selectedTab_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">selectedTab_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="selectedTab_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- courses -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">courses_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="courses_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- selectedCourse_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">selectedCourse_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="selectedCourse_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- modules -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">modules_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="modules_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- selectedModule_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">selectedModule_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_"
													v-text="selectedModule_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- state_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">state_</span>
									</v-col>
								</v-row>
								<template v-for="(val, key) in state_">
									<v-row :key="key" class="px-2" dense>
										<v-col>
											<v-alert
													class="customVAlert"
													color="error"
													outlined>
												<pre	class="prettyprint caption pretty_"
														v-text="val" />
											</v-alert>
										</v-col>
									</v-row>
								</template>
								<!-- courseParamsLeft_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">courseParamsLeft_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="courseParamsLeft_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- courseParamsRight_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">courseParamsRight_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="courseParamsRight_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- moduleParamsLeft_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">moduleParamsLeft_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="moduleParamsLeft_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- moduleParamsRight_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">moduleParamsRight_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="moduleParamsRight_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- sectionParamsLeft_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">sectionParamsLeft_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="sectionParamsLeft_" />
										</v-alert>
									</v-col>
								</v-row>
								<!-- sectionParamsRight_ -->
								<v-row class="px-2" dense>
									<v-col cols="auto">
										<span class="title_ caption">sectionParamsRight_</span>
									</v-col>
								</v-row>
								<v-row class="px-2" dense>
									<v-col>
										<v-alert
												class="customVAlert"
												color="error"
												outlined>
											<pre	class="prettyprint caption pretty_ debug_"
													v-text="sectionParamsRight_" />
										</v-alert>
									</v-col>
								</v-row>
							</v-card>
						</v-dialog>
					</v-col>
				</template>
			</v-row>
			<!-- courses -->
			<v-row class="px-2" align="center">
				<v-col cols="3">
					<v-alert
							class="customVAlert"
							color="success"
							dark>
						<span class="caption">COURSE</span>
					</v-alert>
				</v-col>
				<v-col>
					<v-tabs-items v-model="selectedTab_">
						<v-combobox
								v-model="selectedCourse_"
								color="success"
								:items="courses_[selectedTab_]" />
					</v-tabs-items>
				</v-col>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="success"
							:disabled="!selectedCourse_"
							icon
							small
							@click="$_bldrTrnDlg_setCourseParams()">
						<v-icon>build</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-dialog
							v-model="showDialogJSON_.course"
							persistent
							width="750px">
						<template v-slot:activator="{ on }">
							<v-btn	class="customVBtn"
									color="success"
									:disabled="!selectedCourse_"
									icon
									@click="$_bldrTrnDlg_openTextarea('course', on)">
								<v-icon>code</v-icon>
							</v-btn>
						</template>
						<v-card class="customVCard">
							<v-card-text>
								<v-textarea v-model="courseParamsJSON_" />
							</v-card-text>
							<v-card-actions>
								<v-row dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="success"
												@click="$_bldrTrnDlg_updateParamsWithJSON('course')">
											Set
										</v-btn>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="secondary"
												@click="$_bldrTrnDlg_closeTextarea('course')">
											Cancel
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
			</v-row>
			<!-- courses (input fields) -->
			<template v-for="(paramVal, paramKey) in sortObject(courseParamsLeft_)">
				<v-row class="px-2" :key="`course-${paramKey}`">
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<span	class="caption dev_"
									v-text="paramKey" />
						</v-alert>
					</v-col>
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<pre	class="prettyprint caption pretty_ dev_"
									v-text="paramVal" />
						</v-alert>
					</v-col>
					<v-col class="px-0" cols="auto">
						<v-btn	class="customVBtn"
								color="success"
								icon
								@click="$_bldrTrnDlg_updateCourseParams(paramKey)">
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col>
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<v-textarea
									v-model="courseParamsRight_[paramKey]"
									auto-grow
									class="prettyprint caption pretty_"
									color="success"
									dense
									hide-details
									rows="1" />
						</v-alert>
					</v-col>
				</v-row>
			</template>
			<!-- modules -->
			<v-row class="px-2" align="center">
				<v-col cols="3">
					<v-alert
							class="customVAlert"
							color="success"
							dark>
						<span class="caption">MODULE</span>
					</v-alert>
				</v-col>
				<v-col>
					<v-combobox
							v-model="selectedModule_"
							color="success"
							:items="modules_" />
				</v-col>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="success"
							:disabled="!selectedModule_"
							icon
							small
							@click="$_bldrTrnDlg_setModuleParams()">
						<v-icon>build</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-dialog
							v-model="showDialogJSON_.module"
							persistent
							width="750px">
						<template v-slot:activator="{ on }">
							<v-btn	class="customVBtn"
									color="success"
									:disabled="!selectedModule_"
									icon
									@click="$_bldrTrnDlg_openTextarea('module', on)">
								<v-icon>code</v-icon>
							</v-btn>
						</template>
						<v-card class="customVCard">
							<v-card-text>
								<v-textarea v-model="moduleParamsJSON_" />
							</v-card-text>
							<v-card-actions>
								<v-row dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="success"
												@click="$_bldrTrnDlg_updateParamsWithJSON('module')">
											Set
										</v-btn>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="secondary"
												@click="$_bldrTrnDlg_closeTextarea('module')">
											Cancel
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
			</v-row>
			<!-- modules (input fields) -->
			<template v-for="(paramVal, paramKey) in sortObject(moduleParamsLeft_)">
				<v-row class="px-2" :key="`module-${paramKey}`">
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<span	class="caption dev_"
									v-text="paramKey" />
						</v-alert>
					</v-col>
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<pre	class="prettyprint caption pretty_ dev_"
									v-text="paramVal" />
						</v-alert>
					</v-col>
					<v-col class="px-0" cols="auto">
						<v-btn	class="customVBtn"
								color="success"
								icon
								@click="$_bldrTrnDlg_updateModuleParams(paramKey)">
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col>
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<v-textarea
									v-model="moduleParamsRight_[paramKey]"
									auto-grow
									class="prettyprint caption pretty_"
									color="success"
									dense
									hide-details
									rows="1" />
						</v-alert>
					</v-col>
				</v-row>
			</template>
			<!-- sections -->
			<v-row class="px-2" align="center">
				<v-col cols="3">
					<v-alert
							class="customVAlert"
							color="success"
							dark>
						<span class="caption">SECTION</span>
					</v-alert>
				</v-col>
				<v-col>
					<v-combobox
							v-model="selectedSection_"
							color="success"
							:items="sections_" />
				</v-col>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="success"
							:disabled="!selectedSection_"
							icon
							small
							@click="$_bldrTrnDlg_setSectionParams()">
						<v-icon>build</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-dialog
							v-model="showDialogJSON_.section"
							persistent
							width="750px">
						<template v-slot:activator="{ on }">
							<v-btn	class="customVBtn"
									color="success"
									:disabled="!selectedSection_"
									icon
									@click="$_bldrTrnDlg_openTextarea('section', on)">
								<v-icon>code</v-icon>
							</v-btn>
						</template>
						<v-card class="customVCard">
							<v-card-text>
								<v-textarea v-model="sectionParamsJSON_" />
							</v-card-text>
							<v-card-actions>
								<v-row dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="success"
												@click="$_bldrTrnDlg_updateParamsWithJSON('section')">
											Set
										</v-btn>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												color="secondary"
												@click="$_bldrTrnDlg_closeTextarea('section')">
											Cancel
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
			</v-row>
			<!-- sections (input fields) -->
			<template v-for="(paramVal, paramKey) in sortObject(sectionParamsLeft_)">
				<v-row class="px-2" :key="`section-${paramKey}`">
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<span	class="caption dev_"
									v-text="paramKey" />
						</v-alert>
					</v-col>
					<v-col cols="3">
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<pre	class="prettyprint caption pretty_ dev_"
									v-text="paramVal" />
						</v-alert>
					</v-col>
					<v-col class="px-0" cols="auto">
						<v-btn	class="customVBtn"
								color="success"
								icon
								@click="$_bldrTrnDlg_updateSectionParams(paramKey)">
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col>
						<v-alert
								class="customVAlert"
								color="success"
								outlined>
							<v-textarea
									v-model="sectionParamsRight_[paramKey]"
									auto-grow
									class="prettyprint caption pretty_"
									color="success"
									dense
									hide-details
									rows="1" />
						</v-alert>
					</v-col>
				</v-row>
			</template>
			<!-- buttons -->
			<v-row class="px-2 pb-3" justify="center" dense>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="success"
							:disabled="(!courseParamsUpdated_ || !selectedCourse_) && (!moduleParamsUpdated_ || !selectedModule_) && (!sectionParamsUpdated_ || !selectedSection_)"
							large
							@click="$_bldrTrnDlg_save(false)">
						<template v-if="isFalse(onProgress_)">
							Save
						</template>
						<template v-else>
							<progress-circular />
						</template>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="success"
							:disabled="(!courseParamsUpdated_ || !selectedCourse_) && (!moduleParamsUpdated_ || !selectedModule_) && (!sectionParamsUpdated_ || !selectedSection_)"
							large
							@click="$_bldrTrnDlg_save(true)">
						<template v-if="isFalse(onProgress_)">
							Save & Reload
						</template>
						<template v-else>
							<progress-circular />
						</template>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							color="secondary"
							large
							@click="$_bldrTrnDlg_close()">
						Close
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'BuilderTrainingDialog',
		data() {
			return {
				showDialog_: false,
				showDialogJSON_: {
					course: false,
					module: false,
					section: false
				},
				// tab
				tabs_: [ 'trainings' ],
				selectedTab_: 0,
				// training
				courses_: [],
				selectedCourse_: null,
				modules_: [],
				selectedModule_: null,
				sections_: [],
				selectedSection_: null,
				// state
				state_: [
					{
						new: {}
					}
				],
				// params
				courseParamsLeft_: {},
				courseParamsRight_: {},
				courseParamsJSON_: null,
				courseParamsUpdated_: false,
				// training params
				moduleParamsLeft_: {},
				moduleParamsRight_: {},
				moduleParamsJSON_: null,
				moduleParamsUpdated_: false,
				// training params
				sectionParamsLeft_: {},
				sectionParamsRight_: {},
				sectionParamsJSON_: null,
				sectionParamsUpdated_: false,
				// save button
				onProgress_: false
			}
		},
		computed: {
			// state
			$_bldrTrnDlg_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_bldrTrnDlg_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_bldrTrnDlg_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			$_bldrTrnDlg_stateTrainings() {
				const self_ = this;
				return () => {
					return self_.getTrainingsState()
				}
			}
		},
		methods: {
			$_bldrTrnDlg_setTrainingsState() {
				const self_ = this;
				const trainings_ = self_.$_bldrTrnDlg_stateTrainings();
				// set state
				self_.state_[0] = trainings_;
				// clear & set items
				const courses_ = self_.sortObject(trainings_, 'order')
				self_.courses_[0] = Object.keys(courses_)
			},
			$_bldrTrnDlg_setCourseParams() {
				const self_ = this;

				self_.courseParamsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_][self_.selectedCourse_])
				self_.courseParamsRight_ = {}
				self_.courseParamsUpdated_ = false;

				const modules_ = self_.sortObject(self_.courseParamsLeft_.modules, 'order')
				self_.modules_ = Object.keys(modules_)
				self_.modules_.push('new')
				delete self_.courseParamsLeft_.modules;

				Object.keys(self_.courseParamsLeft_).forEach(key => {
					// object
					if(self_.isObject(self_.courseParamsLeft_[key]) || JSON.stringify(self_.courseParamsLeft_[key]) == '{}') {
						self_.courseParamsRight_[key] = JSON.stringify(self_.courseParamsLeft_[key])
					// boolean
					} else if(self_.isBoolean(self_.courseParamsLeft_[key])) {
						if(self_.courseParamsLeft_[key]) { self_.courseParamsRight_[key] = 1 }
						else { self_.courseParamsRight_[key] = 0 }
					// null
					} else if(self_.isFalse(self_.courseParamsLeft_[key])) {
						self_.courseParamsRight_[key] = 'NULL';
					// text
					} else {
						self_.courseParamsRight_[key] = self_.courseParamsLeft_[key]
					}
				})
			},
			$_bldrTrnDlg_setModuleParams() {
				const self_ = this;

				if(self_.selectedModule_ == 'new') {
					self_.moduleParamsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_].new.modules.new)
				} else {
					self_.moduleParamsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_][self_.selectedCourse_].modules[self_.selectedModule_])	
				}
				self_.moduleParamsRight_ = {}
				self_.moduleParamsUpdated_ = false;

				const sections_ = self_.sortObject(self_.moduleParamsLeft_.sections, 'order')
				self_.sections_ = Object.keys(sections_)
				self_.sections_.push('new')
				delete self_.moduleParamsLeft_.sections;

				Object.keys(self_.moduleParamsLeft_).forEach(key => {
					if(key != 'sections') {
						// object
						if(self_.isObject(self_.moduleParamsLeft_[key]) || JSON.stringify(self_.moduleParamsLeft_[key]) == '{}') {
							self_.moduleParamsRight_[key] = JSON.stringify(self_.moduleParamsLeft_[key])
						// boolean
						} else if(self_.isBoolean(self_.moduleParamsLeft_[key])) {
							if(self_.moduleParamsLeft_[key]) { self_.moduleParamsRight_[key] = 1 }
							else { self_.moduleParamsRight_[key] = 0 }
						// null
						} else if(self_.isFalse(self_.moduleParamsLeft_[key])) {
							self_.moduleParamsRight_[key] = 'NULL';
						// text
						} else {
							self_.moduleParamsRight_[key] = self_.moduleParamsLeft_[key]
						}
					}
				})
			},
			$_bldrTrnDlg_setSectionParams() {
				const self_ = this;

				if(self_.selectedSection_ == 'new') {
					self_.sectionParamsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_].new.modules.new.sections.new)
				} else {
					self_.sectionParamsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_][self_.selectedCourse_].modules[self_.selectedModule_].sections[self_.selectedSection_])
				}
				self_.sectionParamsRight_ = {}
				self_.sectionParamsUpdated_ = false;

				Object.keys(self_.sectionParamsLeft_).forEach(key => {
					if(key != 'sections') {
						// object
						if(self_.isObject(self_.sectionParamsLeft_[key]) || JSON.stringify(self_.sectionParamsLeft_[key]) == '{}') {
							self_.sectionParamsRight_[key] = JSON.stringify(self_.sectionParamsLeft_[key])
						// boolean
						} else if(self_.isBoolean(self_.sectionParamsLeft_[key])) {
							if(self_.sectionParamsLeft_[key]) { self_.sectionParamsRight_[key] = 1 }
							else { self_.sectionParamsRight_[key] = 0 }
						// null
						} else if(self_.isFalse(self_.sectionParamsLeft_[key])) {
							self_.sectionParamsRight_[key] = 'NULL';
						// text
						} else {
							self_.sectionParamsRight_[key] = self_.sectionParamsLeft_[key]
						}
					}
				})
			},
			$_bldrTrnDlg_updateCourseParams(key) {
				const self_ = this;

				// object
				if(self_.isObject(self_.courseParamsLeft_[key]) || JSON.stringify(self_.courseParamsLeft_[key]) == '{}') {
					self_.courseParamsLeft_[key] = JSON.parse(self_.courseParamsRight_[key])
				// boolean
				} else if(self_.isBoolean(self_.courseParamsLeft_[key])) {
					if(self_.courseParamsRight_[key] == 0) { self_.courseParamsLeft_[key] = false }
					else { self_.courseParamsLeft_[key] = true }
				// null
				} else if(self_.courseParamsRight_[key].toLowerCase() == 'null') {
					self_.courseParamsLeft_[key] = null;
				// text & number
				} else {
					if(self_.isNumber(self_.courseParamsLeft_[key])) {
						self_.courseParamsLeft_[key] = Number(self_.courseParamsRight_[key])
					} else {
						self_.courseParamsLeft_[key] = self_.courseParamsRight_[key]
					}
				}

				self_.courseParamsUpdated_ = true;
			},
			$_bldrTrnDlg_updateModuleParams(key) {
				const self_ = this;

				// object
				if(self_.isObject(self_.moduleParamsLeft_[key]) || JSON.stringify(self_.moduleParamsLeft_[key]) == '{}') {
					self_.moduleParamsLeft_[key] = JSON.parse(self_.moduleParamsRight_[key])
				// boolean
				} else if(self_.isBoolean(self_.moduleParamsLeft_[key])) {
					if(self_.moduleParamsRight_[key] == 0) { self_.moduleParamsLeft_[key] = false }
					else { self_.moduleParamsLeft_[key] = true }
				// null
				} else if(self_.moduleParamsRight_[key].toLowerCase() == 'null') {
					self_.moduleParamsLeft_[key] = null;
				// text & number
				} else {
					if(self_.isNumber(self_.moduleParamsLeft_[key])) {
						self_.moduleParamsLeft_[key] = Number(self_.moduleParamsRight_[key])
					} else {
						self_.moduleParamsLeft_[key] = self_.moduleParamsRight_[key]
					}
				}

				self_.moduleParamsUpdated_ = true;
			},
			$_bldrTrnDlg_updateSectionParams(key) {
				const self_ = this;

				// object
				if(self_.isObject(self_.sectionParamsLeft_[key]) || JSON.stringify(self_.sectionParamsLeft_[key]) == '{}') {
					self_.sectionParamsLeft_[key] = JSON.parse(self_.sectionParamsRight_[key])
				// boolean
				} else if(self_.isBoolean(self_.sectionParamsLeft_[key])) {
					if(self_.sectionParamsRight_[key] == 0) { self_.sectionParamsLeft_[key] = false }
					else { self_.sectionParamsLeft_[key] = true }
				// null
				} else if(self_.sectionParamsRight_[key].toLowerCase() == 'null') {
					self_.sectionParamsLeft_[key] = null;
				// text & number
				} else {
					if(self_.isNumber(self_.sectionParamsLeft_[key])) {
						self_.sectionParamsLeft_[key] = Number(self_.sectionParamsRight_[key])
					} else {
						self_.sectionParamsLeft_[key] = self_.sectionParamsRight_[key]
					}
				}

				self_.sectionParamsUpdated_ = true;
			},
			$_bldrTrnDlg_openTextarea(type) {
				const self_ = this;

				if(type == 'course') { self_.courseParamsJSON_ = JSON.stringify(self_.courseParamsLeft_) }
				if(type == 'module') { self_.moduleParamsJSON_ = JSON.stringify(self_.moduleParamsLeft_) }
				if(type == 'section') { self_.sectionParamsJSON_ = JSON.stringify(self_.sectionParamsLeft_) }
				
				self_.showDialogJSON_[type] = true;
			},
			$_bldrTrnDlg_closeTextarea(type) {
				const self_ = this;
				self_.showDialogJSON_[type] = false;
			},
			$_bldrTrnDlg_updateParamsWithJSON(type) {
				const self_ = this;

				let json_ = {}
				if(type == 'course') {
					self_.courseParamsLeft_ = JSON.parse(self_.courseParamsJSON_)
					self_.courseParamsUpdated_ = true;	
				}
				if(type == 'module') {
					self_.moduleParamsLeft_ = JSON.parse(self_.moduleParamsJSON_)
					self_.moduleParamsUpdated_ = true;	
				}
				if(type == 'section') {
					self_.sectionParamsLeft_ = JSON.parse(self_.sectionParamsJSON_)
					self_.sectionParamsUpdated_ = true;	
				}

				self_.showDialogJSON_[type] = false;
			},
			$_bldrTrnDlg_save(reload) {
				const self_ = this;

				self_.onProgress_ = true;

				const type_ = self_.tabs_[self_.selectedTab_]; // type = training

				let courseKey_ = null;
				if(self_.selectedCourse_ == 'new') { courseKey_ = self_.getChanceDocumentKey() }
				else { courseKey_ = self_.selectedCourse_; }
				let moduleKey_ = null;
				if(self_.selectedModule_ == 'new') { moduleKey_ = self_.getChanceDocumentKey() }
				else { moduleKey_ = self_.selectedModule_; }
				let sectionKey_ = null;
				if(self_.selectedSection_ == 'new') { sectionKey_ = self_.getChanceDocumentKey() }
				else { sectionKey_ = self_.selectedSection_; }

				let promiseArray_ = []

				if(!self_.isFalse(courseKey_)) { promiseArray_.push(self_.setFirestoreDocument(type_, courseKey_, self_.courseParamsLeft_)) }
				if(!self_.isFalse(moduleKey_)) { promiseArray_.push(self_.setFirestoreSubDocument(type_, courseKey_, 'modules', moduleKey_, self_.moduleParamsLeft_)) }
				if(!self_.isFalse(sectionKey_)) { promiseArray_.push(self_.setFirestoreSubSubDocument(type_, courseKey_, 'modules', moduleKey_, 'sections', sectionKey_, self_.sectionParamsLeft_)) }

				Promise.resolve().then(() => {
					return Promise.all(promiseArray_)
				}).then(() => {
					if(reload) { self_.$_bldrTrnDlg_reload() }
					else { self_.$_bldrTrnDlg_reset() }
				}).catch(error => {
					console.log(error)
				})
			},
			$_bldrTrnDlg_reset() {
				const self_ = this;

				self_.selectedCourse_ = null;
				self_.selectedModule_ = null;
				self_.selectedSection_ = null;

				self_.courseParamsLeft_ = {}
				self_.courseParamsRight_ = {}
				self_.courseParamsJSON_ = null;
				self_.courseParamsUpdated_ = false;
				self_.moduleParamsLeft_ = {}
				self_.moduleParamsRight_ = {}
				self_.moduleParamsJSON_ = null;
				self_.moduleParamsUpdated_ = false;
				self_.sectionParamsLeft_ = {}
				self_.sectionParamsRight_ = {}
				self_.sectionParamsJSON_ = null;
				self_.sectoinParamsUpdated_ = false;

				self_.onProgress_ = false;
				self_.showDialogJSON_ = {
					course: false,
					module: false,
					section: false
				}
			},
			$_bldrTrnDlg_reload() {
				const self_ = this;
				self_.openLink({ method: { name: 'reload' }})
			},
			$_bldrTrnDlg_close() {
				const self_ = this;

				self_.showDialog_ = false;

				self_.selectedTab_ = 0;
				self_.$_bldrTrnDlg_reset()
				
				self_.$_bldrTrnDlg_setTrainingsState()
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.title_ {
		color: #ff5252;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
	.mergin_ {
		margin-top: 0;
		margin-bottom: 0;
	}
	.pretty_ {
		border: none;
	}
	.debug_ {
		color: #ff5252;
	}
	.dev_ {
		color: #4caf50;
	}
</style>
